﻿import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import TileWMS from 'ol/source/TileWMS.js';
import Feature from 'ol/Feature.js';
import Polygon from 'ol/geom/Polygon.js';
import MultiPolygon from 'ol/geom/MultiPolygon.js';
import WKT from 'ol/format/WKT.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { defaults as defaultControls, ScaleLine } from 'ol/control.js';
import { defaults as defaultInteractions } from 'ol/interaction.js';
import { addProjection } from 'ol/proj.js';
import Projection from 'ol/proj/Projection.js';
import { get as getProjection } from 'ol/proj.js';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';
import { get } from 'http';
import { Utility } from './Utility';
export { Pdm };

/**
 * Class PDM
 */
const Pdm = function () {
    // Define this
    var myPdm = this;

    // -- begin private variable ------------------------------------------------------------------

    // The map
    this._map = null;

    // User id
    this._userId = -1;

    // Owner pdm code
    this._codOwner = "";

    // -- Request variable --
    this._requestTypes = {};
    this._requestStatuses = {};
    this._legalDocuments = {};
    this._last3Requests = [];
    this._requests = [];

    // Layer tree
    this._layerTree = null;

    this._analiseCondicionantes = false;
    this._plantasLocalizacao = false;

    // Report in location plant
    this._reportLocationPlant = false;

    // Pdm id node
    this._pdmIdNode = "";

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method  --------------------------------------------------------------------

    /**
     * Init pdm
     * @param {ol.map} theMap, the map
     * @param {object} layerTree, layer tree object
     * @param {object} visibleOperations, all visible operation
     * @param {string} codOwner, owner code
     * @param {int} userId, user id
     */
    this.Init = function (theMap, layerTree, visibleOperations, codOwner, userId) {
        // Map
        myPdm._map = theMap;

        // CodOwner
        myPdm._codOwner = codOwner;

        // Layer tree
        myPdm._layerTree = layerTree;

        myPdm._analiseCondicionantes = visibleOperations && visibleOperations.AnaliseCondicionantes;
        myPdm._plantasLocalizacao = visibleOperations && visibleOperations.PlantasLocalizacao;

        // Fill request statuses
        myPdm._FillRequestStatuses(codOwner);

        // Define click/touchstart reload event
        $('#pdm-tabs-reload-button').on('click', myPdm._FillRequests).on('touchstart', myPdm._FillRequests);

        // Define click/touchstart submit request event
        $('#pdm-request-submit').on('click', myPdm._HandlePDMRequest).on('touchstart', myPdm._HandlePDMRequest);

        // Add date picker lib to form date
        $('.date', $('#offcanvas-pdm')).each(function () { $(this).datepicker(); });

        // User Id
        myPdm._userId = userId;
    };

    /**
     * Init report page
     * @param {int} reqId, request id
     */
    this.InitReport = function (reqId) {
        this._LoadRequestForReport(reqId);
    };

    /**
     * Set map to use in pdm
     * @param {ol.map} map, the map
     */
    this.SetMap = function (map) {
        myPdm.map = map;
    };

    // -- end public method  ----------------------------------------------------------------------

    // -- begin private method  -------------------------------------------------------------------

    /**
     * Fill request statuses
     */
    this._FillRequestStatuses = function (codOwner) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetRequestStatuses',
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter estados de pedidos: " + data.error);
                }
                else {
                    for (var r in data.result) {
                        myPdm._requestStatuses[data.result[r].id] = { name: data.result[r].name, code: data.result[r].code };
                    }
                    myPdm._FillLegalDocuments(codOwner);
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter estados de pedidos");
            }
        });
    };

    /**
     * Fill legal document
     * @param {string} codOwner, owner code
     */
    this._FillLegalDocuments = function (codOwner) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/PDM/GetLegal_Document?codOwner=' + codOwner,
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter documentos legais: " + data.error);
                }
                else {
                    for (var r in data.result) {
                        myPdm._legalDocuments[data.result[r].id] = data.result[r].name;
                    }
                    myPdm._FillRequestTypes();
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter documentos legais");
            }
        });
    };

    /**
     * Fill legal document
     * @param {string} codOwner, owner code
     */
    this._SetLegalDocuments = function (codOwner) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/PDM/GetLegal_Document?codOwner=' + codOwner,
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter documentos legais do PDM");
                }
                else {
                    for (var r in data.result) {
                        myPdm._legalDocuments[data.result[r].id] = data.result[r].name;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter documentos legais do PDM");
            }
        });
    };

    /**
     * Fill request types
     */
    this._FillRequestTypes = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetRequestTypes',
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter tipos de pedidos: " + data.error);
                }
                else {
                    for (var r in data.result) {
                        let isAnaliseCond = data.result[r].code !== 'PDM_CONDICIONANTE';
                        let isPlantaLoc = data.result[r].code !== 'LOCATION_ANALYSIS';
                        if ((isAnaliseCond && myPdm._analiseCondicionantes) || (isPlantaLoc && myPdm._analiseCondicionantes))
                            myPdm._requestTypes[data.result[r].id] = { name: data.result[r].name, code: data.result[r].code };
                    }
                    myPdm._FillFormSelects();
                    myPdm._FillRequests();
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter tipos de pedidos");
            }
        });
    };

    /**
     * Fill request types
     */
    this._SetRequestTypes = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetRequestTypes',
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção dos tipos de pedidos de pdm");
                }
                else {
                    for (var item in data.result) {
                        myPdm._requestTypes[data.result[item].id] = { id: data.result[item].id, name: data.result[item].name, code: data.result[item].code };
                        myPdm._requestTypes[data.result[item].code] = { id: data.result[item].id, name: data.result[item].name, code: data.result[item].code };
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção dos tipos de pedidos de pdm");
            }
        });
    };

    /**
     * Fill requests uls
     */
    this._FillRequests = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetRequestsByUser?userId=' + myPdm._userId + '&maxResults=3',
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter pedidos: " + data.error);
                }
                else {
                    myPdm._last3Requests = [];
                    for (var r in data.result) {
                        myPdm._last3Requests.push(data.result[r]);
                    }
                    var histURL = '/rest/app/Request/GetRequestsByUser?userId=' + myPdm._userId;
                    if ($('#pdm-date-from').val() !== '') {
                        var from = new Date(Date.parse($('#pdm-date-from').val()));
                        from.setHours(0, 0, 0, 0);
                        histURL += '&from=' + from.toISOString();
                    }
                    if ($('#pdm-date-until').val() !== '') {
                        var until = new Date(Date.parse($('#pdm-date-until').val()));
                        until.setHours(23, 59, 59, 999);
                        histURL += '&until=' + until.toISOString();
                    }
                    $.ajax({
                        type: 'GET',
                        url: histURL,
                        dataType: 'json',
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro ao obter histórico de pedidos: " + data.error);
                            }
                            else {
                                myPdm._requests = [];
                                for (var r in data.result) {
                                    myPdm._requests.push(data.result[r]);
                                }
                                myPdm._FillPDMRequestsList();
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro ao obter histórico de pedidos");
                        }
                    });
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter pedidos");
            }
        });
    };

    /**
     * Fill forms select option
     */
    this._FillFormSelects = function () {
        var selReqType = $('#pdm-request-type');
        for (var rt in myPdm._requestTypes)
            selReqType.append($('<option value="' + rt + '">' + myPdm._requestTypes[rt].name + '</option>'));
        if (Object.keys(myPdm._requestTypes).length > 1)
            selReqType.selectpicker('refresh');
        else $(selReqType.parents('div.form-group')[0]).hide();

        var selLegalDoc = $('#pdm-request-legaldoc');
        for (var ld in myPdm._legalDocuments)
            selLegalDoc.append($('<option value="' + ld + '">' + myPdm._legalDocuments[ld] + '</option>'));
        if (Object.keys(myPdm._legalDocuments).length > 0)
            selLegalDoc.selectpicker('refresh');
        else $(selLegalDoc.parents('div.form-group')[0]).hide();
    };

    /**
     * Load request
     * @param {any} request, request
     */
    this._LoadRequest = function (request) {
        $('#offcanvas-pdm-legend').removeClass('show');
        app.layerDraw.getSource().clear();
        app.layerDraw.getSource().addFeature(new Feature({
            id: 'req_' + request.id,
            geometry: new WKT().readGeometry(request.geomWKT)
        }));

        myPdm._map.getView().fit(app.layerDraw.getSource().getExtent(), { duration: 1000, maxZoom: 9 });

        $('#pdm-request-legaldoc').val(request.legalDocument);
        $('#pdm-request-type').val(request.pdmRequestType);
        $('#pdm-request-nproc').val(request.nProc);
        $('#pdm-request-description').val(request.description);
        if (!$('#pdm_request_tab').hasClass('active'))
            $('#pdm_request_tab').addClass('active');
        if ($('#pdm_request_history_tab').hasClass('active'))
            $('#pdm_request_history_tab').removeClass('active');
        if (!$('#pdm_request_tab_li').hasClass('active'))
            $('#pdm_request_tab_li').addClass('active');
        if ($('#pdm_request_history_tab_li').hasClass('active'))
            $('#pdm_request_history_tab_li').removeClass('active');

        if (myPdm._requestStatuses[request.status].code === 'FINISHED') {
            myPdm._LoadAnswer(request);
        }
    };

    /**
     * Fill pdm list
     */
    this._FillPDMRequestsList = function () {
        $('#pdm_last_requests').empty();
        $('#pdm_requests').empty();

        for (var i = 0; i < myPdm._requests.length; i++) {
            var req = myPdm._requests[i];
            var d = new Date(req.submissionDate);
            var li = '<li class="tile pdm-request-list-item pdm-request-list-item-' + req.id + '" title="' + (req.description ? req.description : '') + '">'
                + '<a class="tile-content">'
                + '<div class="tile-text">' + req.nProc + ' [<span class="pdm-status-for-req-' + req.id + '">' + myPdm._requestStatuses[req.status].name + '</span>]'
                + '<small>' + d.toLocaleDateString('pt-PT') + ' ' + d.toLocaleTimeString('pt-PT') + '</small>'
                + '<small>' + myPdm._requestTypes[req.pdmRequestType].name + '</small>'
                + '</div></a>'
                + '<a class="btn btn-flat btn-primary load-request-answer"><i class="zmdi zmdi-gps-dot" ></i></a>'
                + '</li>';
            if (i < 3)
                $('#pdm_last_requests').append($(li).data('pdm_req', req));
            $('#pdm_requests').append($(li).data('pdm_req', req));
        }

        var openRequest = function () {
            var req = $(this).parent('li').data('pdm_req');
            $('.pdm-request-list-item').removeClass('selected');
            $('.pdm-request-list-item-' + req.id).addClass('selected');
            myPdm._LoadRequest(req);
        };

        $('.load-request-answer').on('click', openRequest);
        $('.load-request-answer').on('touchstart', openRequest);
    };

    /**
     * Load answer
     * @param {object} request, request
     */
    this._LoadAnswer = function (request) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetAnswerForRequest?requestId=' + request.id,
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter resposta ao pedido " + request.id + ": " + data.error);
                }
                else {
                    myPdm._layerTree.uncheckAll();
                    $('#pdm-legend-div').empty();
                    var legendList = $('<ul class="list pdm-legend-list"></ul>');
                    var layersUrl = '/rest/app/Layer/GetLayersById?';
                    var elementsByLayer = {};
                    for (var layer in data.result.elements) {

                        for (var l in data.result.elements[layer].layerIds) {
                            var lid = data.result.elements[layer].layerIds[l];
                            myPdm._layerTree.check(myPdm._layerTree.getNodeById(lid));
                            var param = '&ids=' + lid;
                            layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                            if (!elementsByLayer[lid])
                                elementsByLayer[lid] = [];
                            elementsByLayer[lid].push(data.result.elements[layer]);
                        }
                    }
                    $.ajax({
                        type: 'GET',
                        url: layersUrl,
                        dataType: 'json',
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro ao obter layers da resposta ao pedido " + request.id + ": " + data.error);
                            } else {
                                var reqArea = (myPdm._requestTypes[request.pdmRequestType].code === 'PDM_CONDICIONANTE' || myPdm._requestTypes[request.pdmRequestType].code === 'PDM_ORDENAMENTO') ? new WKT().readGeometry(request.geomWKT).getArea() : undefined;
                                for (var l in data.result) {
                                    var layer = data.result[l];
                                    var li = $('<li style="padding:3px;" title="' + (layer.description ? layer.description : '') + '"></li>');
                                    li.append('<img src = "' + layer.legendUrl + '"/>');
                                    var span = $('<span style = "padding:3px;" ></span>');
                                    span.html(layer.text
                                        + (reqArea && elementsByLayer[layer.id].length > 0 && elementsByLayer[layer.id][0].intersectionArea > 0
                                            ? ' (' + (elementsByLayer[layer.id][0].intersectionArea / reqArea * 100).toFixed(2) + '%)'
                                            : ''));
                                    li.append(span);
                                    legendList.append(li);
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro ao obter layers da resposta ao pedido " + request.id);
                        }
                    });
                    $('#pdm-legend-div').append(legendList);
                    $('#offcanvas-pdm-legend').addClass('show');

                    $('#pdm-report-button').data('reqId', request.id);
                    $('#pdm-report-button').click(function () {
                        var url = '/Request?ID=' + $(this).data('reqId') + '&size=' + $('#pdm-report-size').val() + '&layout=' + $('#pdm-report-layout').val();
                        window.open(url, '_blank');
                    });
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter resposta ao pedido " + request.id);
            }
        });
    };

    /**
     * PDM - submit a request
     */
    this._HandlePDMRequest = function () {
        var geom = null, geoms = [];
        if (app.layerDraw
            && app.layerDraw.getSource()
            && app.layerDraw.getSource().getFeatures()
            && app.layerDraw.getSource().getFeatures().length > 0) {
            for (var f = 0; f < app.layerDraw.getSource().getFeatures().length; f++)
                if (app.layerDraw.getSource().getFeatures()[f].getGeometry() && app.layerDraw.getSource().getFeatures()[f].getGeometry() instanceof Polygon)
                    geoms.push(app.layerDraw.getSource().getFeatures()[f].getGeometry());
            if (geoms.length > 0)
                geom = new MultiPolygon(geoms);
        }

        // Check if any polygon is drawn
        if (geom === null) {
            toastr["warning"]("Deve desenhar um polígono primeiro.");
            return;
        }

        var reqType = Number.parseInt($('#pdm-request-type').val());

        $.ajax({
            type: 'POST',
            url: '/rest/app/Request/CreateRequest',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify({
                "nProc": $('#pdm-request-nproc').val(),
                "description": $('#pdm-request-description').val(),
                "pdmRequestType": reqType,
                "legalDocument": Number.parseInt($('#pdm-request-legaldoc').val()),
                "user": myPdm._userId,
                "geomWKT": new WKT().writeGeometry(geom),
                "geomSrid": Number.parseInt(myPdm._map.getView().getProjection().getCode().replace('EPSG:', ''))
            }),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao submeter pedido de " + myPdm._requestTypes[reqType].name + ": " + data.error);
                }
                else {
                    app.layerDraw.getSource().clear();
                    myPdm._FillRequests();
                    $('#pdm-request-description').val('');
                    $('#pdm-request-nproc').val('');
                    toastr["success"]("Pedido de " + myPdm._requestTypes[reqType].name + " submetido com sucesso. ID: " + data.result);
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao submeter pedido de " + myPdm._requestTypes[reqType].name);
            }
        });
    };

    /**
     * Create pdm request
     * @param {object} locationPlantInfo, Object with the request information
     * @param {int} idTypeRequest, identifier of the type of the request
     * @param {int} idLegalDocument, identifier of the legal document
     * @param {int} idUser, identifier of the user
     */
    this._CreatePdmRequestForLocationPlant = function (locationPlantInfo, idTypeRequest, idLegalDocument, idUser) {

        $.ajax({
            type: 'POST',
            url: '/rest/app/Request/CreateRequest',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify({
                "nProc": 'Sem processo',
                "description": 'Sem processo',
                "pdmRequestType": idTypeRequest,
                "legalDocument": idLegalDocument,
                "user": idUser,
                "geomWKT": locationPlantInfo.geom_wkt,
                "geomSrid": locationPlantInfo.geom_srid
            }),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação da análise de pdm");
                }
                else {

                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação da análise de pdm");
            }
        });
    }

    /**
     * Load a request for a PDM request report
     * @param {int} reqId The id of the request
     */
    this._LoadRequestForReport = function (reqId) {
        $.ajax({
            async: false,
            type: 'GET',
            url: "/rest/app/Request/GetRequestById2?id=" + reqId,
            success: function (data) {
                var request = data.result;
                $('title').append('Resposta ao pedido ' + request.nProc);
                myPdm._LoadAnswerForReport(request);
                $('h2.title').append(request.namePDMRequestType);
                $('#request-nr-process').html(request.nProc);
                var d = new Date(request.submissionDate);
                $('#request-date').html(d.toLocaleDateString('pt-PT') + ' ' + d.toLocaleTimeString('pt-PT'));
                $('#request-description').html(request.description);
                $('#legal-document').html(request.nameLegalDocument);

                var geom = new WKT().readGeometry(request.geomWKT);
                $('#request-area').html(Number(geom.getArea().toFixed(2)).toLocaleString() + ' m2');
            }
        });
    };

    /**
     * Fill a list (ul dom element) of layers
     * @param {[object]} layers A list of layers
     * @param {object} elementsByLayer A map of articles by layer
     * @param {object} ul DOM element
     * @param {boolean} showArticles if true, shows articles for layers
     * @param {float} reqArea Area of the request polygon 
     */
    this._fillArticlesULForReport = function (layers, elementsByLayer, ul, showArticles, reqArea) {
        for (var l in layers) {
            var layer = layers[l];
            var li = $('<li title="' + (layer.description ? layer.description : '') + '"></li>');
            var div = $('<div class="legend-element-div"></div>');
            li.append(div);
            div.append('<img src = "' + layer.legendUrl + '"/>');
            var span = $('<span class="legend-title"></span>');
            span.html(layer.text
                + (reqArea && elementsByLayer[layer.id].length > 0 && elementsByLayer[layer.id][0].intersectionArea > 0
                    ? ' (' + (elementsByLayer[layer.id][0].intersectionArea / reqArea * 100).toFixed(2) + '%)'
                    : ''));
            div.append(span);
            if (showArticles)
                div.append($('<hr/>'));

            if (showArticles) {
                var articles = elementsByLayer[layer.id];
                articles.sort(function (a, b) { return a.articleOrdinal - b.articleOrdinal; });
                var i = 0;
                for (var a in articles) {
                    li.append($('<div class="article-div">' + (i > 0 ? '<br/>' : '') + '<h3>' + articles[a].articleName + '</h3>' + articles[a].articleText + (i === articles.length - 1 ? '<br/>' : '') + '</div>'));
                    i++;
                }
            }
            ul.append(li);
        }
    };

    /**
     * Load an answer for a PDM request
     * @param {object} request The PDM request
     */
    this._LoadAnswerForReport = function (request) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/Request/GetAnswerForRequest?requestId=' + request.id,
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao obter resposta ao pedido " + request.id + ": " + data.error);
                }
                else {
                    $('#answer-text').html(data.result.text);
                    var d = new Date(data.result.creationDate);
                    $('#answer-date').html(d.toLocaleDateString('pt-PT') + ' ' + d.toLocaleTimeString('pt-PT'));

                    var legendUl = $('<ul class="list pdm-legend-list"></ul>');
                    var articlesUl = $('<ul class="list pdm-legend-list"></ul>');

                    var isIntersec = (request.requestTypeCode === 'PDM_CONDICIONANTE' || request.requestTypeCode === 'PDM_ORDENAMENTO');
                    var reqArea = isIntersec ? new WKT().readGeometry(request.geomWKT).getArea() : undefined;

                    var layersUrl = '/rest/app/Layer/GetLayersById?';
                    var elementsByLayer = {};
                    for (var layer in data.result.elements) {

                        for (var l in data.result.elements[layer].layerIds) {
                            var lid = data.result.elements[layer].layerIds[l];
                            var param = '&ids=' + lid;
                            layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                            if (!elementsByLayer[lid])
                                elementsByLayer[lid] = [];
                            elementsByLayer[lid].push(data.result.elements[layer]);
                        }
                    }
                    $.ajax({
                        type: 'GET',
                        url: layersUrl,
                        dataType: 'json',
                        async: false,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro ao obter layers da resposta ao pedido " + request.id + ": " + data.error);
                            } else {
                                myPdm._fillArticlesULForReport(data.result, elementsByLayer, legendUl, false, reqArea);
                                if (isIntersec)
                                    myPdm._fillArticlesULForReport(data.result, elementsByLayer, articlesUl, true, reqArea);

                                if(myPdm._reportLocationPlant) {
                                    myPdm._GeneratePageReport(request.requestTypeCode);
                                }
                                else {
                                    myPdm._InitMapForReport(request, data.result);
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro ao obter layers da resposta ao pedido " + request.id);
                        }
                    });

                    $('#' + myPdm._pdmIdNode + ' #legend').append(legendUl);
                    $('#' + myPdm._pdmIdNode + ' #articles').append(articlesUl);

                    myPdm._GeneratePageReport(request.requestTypeCode);

                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao obter resposta ao pedido " + request.id);
            }
        });
    };

    /**
     * Create map ol for pdm report
     * @param {object} request, request
     * @param {array} layers, layers array
     */
    this._InitMapForReport = function (request, layers) {

        proj4.defs("EPSG:" + request.geomSrid, '+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
        register(proj4);

        var projection = new Projection({
            code: 'EPSG:' + request.geomSrid,
            units: 'm'
        });
        addProjection(projection);

        var geom = new WKT().readGeometry(request.geomWKT);
        var extent = geom.getExtent();

        var mapLayers = [];
        for (var l in layers) {
            var layer = layers[l];

            var params = { 'LAYERS': layer.workspace + ':' + layer.layerName, 'TILED': true, 'VERSION': '1.1.1' };
            if (layer.sldName)
                params.STYLES = layer.workspace + ":" + layer.sldName.replace('.sld', '');
            if (layer.cqlFilter)
                params.cql_filter = layer.cqlFilter + " and BBOX(geom, " + extent.join(',') + ")";
            var tileLayer = new TileLayer({
                name: layer.workspace + ":" + layer.layerName,
                source: new TileWMS({
                    url: layer.geoserver + '/' + layer.workspace + '/wms',
                    params: params,
                    serverType: 'geoserver',
                    hidpi: false,
                    transition: 0
                })
            });
            mapLayers.push(tileLayer);
        }


        const styleGeom = new Style({
            fill: new Fill({
                color: 'rgba(35, 181, 119, .5)'
            }),
            stroke: new Stroke({
                color: 'rgba(35, 181, 119, 1)',
                width: 2
            })
        });
        const styleGeom2 = new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 4
            })
        });
        var feature = new Feature({
            geometry: geom
        });
        var vector = new VectorLayer({
            source: new VectorSource({
                features: [feature]
            }),
            style: [
                styleGeom2,
                styleGeom
            ]
        });
        mapLayers.push(vector);
        // .AQUI
        var map = new Map({
            controls: defaultControls({ zoom: false }).extend([
                new ScaleLine({
                    units: 'metric'
                })
            ]),
            interactions: defaultInteractions({
                doubleClickZoom: false,
                dragAndDrop: false,
                dragPan: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
            }),
            layers: mapLayers,
            target: 'map',
            view: new View({
                projection: projection,
                extent: extent
            })
        });

        map.getView().fit(extent, map.getSize(), { maxZoom: 9 });
        var center = map.getView().getCenter();
        $('#request-centroid').html('X: ' + Number(center[0].toFixed(2)).toLocaleString() + ' &nbsp; Y:' + Number(center[1].toFixed(2)).toLocaleString());
        $.ajax('/rest/app/layer/GetProjectionByList?listProjectionName=' + map.getView().getProjection().getCode(), {
            dataType: 'json',
            success: function (data) {
                $('#request-centroid').append('<br/>(' + data.result[map.getView().getProjection().getCode()].name + ')');
            }
        });
    };

    /**
     * Generate page for pdm report
     */
    this._GeneratePageReport = function(codeTypePdm) {
        var idPageOrigin = 'id-location-plant-pdmo-report-page-1';
        var idNodePage = "";
        switch(codeTypePdm) {
            case "PDM_ORDENAMENTO":
                idPageOrigin = 'id-location-plant-pdmo-report-page-1';
                idNodePage = "id-location-plant-pdmo-report-page-";
                break;
            case "PDM_CONDICIONANTE":
                idPageOrigin = 'id-location-plant-pdmc-report-page-1';
                idNodePage = "id-location-plant-pdmc-report-page-";
                break;
            case "PDM_PP":
                idPageOrigin = 'id-location-plant-pdmpp-report-page-1';
                idNodePage = "id-location-plant-pdmpp-report-page-";
                break;
            default:
                // do nothing
        }
        
        var fullHeightReport = $('#' + idPageOrigin)[0].scrollHeight;
        var pageHeight = $('.plant-report .wrapper')[0].scrollHeight;
        var nrPage = (Math.floor(fullHeightReport/pageHeight) + ((fullHeightReport%pageHeight > 0)? 1:0)) - 1;
        var templatePage = '<page class="plant-report" size="A4" layout="portrait">'+
                             '<div class="wrapper">' +
                               '<div id="ID_GENERATE" class="div-plant"></div>' +
                             '</div>' +
                           '</page>';

        var constStyleValue = 27.9;
        var marginTopValue = 0;
        var heightValue = 55.8;
        for(var i = 2; i <= nrPage; i++) {
            var idPage = idNodePage + i;
            marginTopValue += constStyleValue;
            if( i > 2)
                heightValue += constStyleValue;
            $('body').append($(templatePage.replace("ID_GENERATE", idPage)));

	        var copy = $("#" + idPageOrigin).clone().attr("id", idPageOrigin + "-copy-" + i).css({
	            "margin-top": "-" + marginTopValue + "cm",
	            "height": heightValue + "cm"});
	        $("#" + idPage).append(copy);
        }
    };
    
    // -- end private method  ---------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Close pdm legend canvas
     */
    $('#close-offcanvas-pdm-legend').on('click', function () {
        $('#offcanvas-pdm-legend').removeClass('show');
    });

    // -- end event -------------------------------------------------------------------------------
};